import type { Prisma } from "@brookbush/database";

export interface UserFlags {
	isAIModalShown?: boolean;
	isGiftCardModalShown?: boolean;
	isWebPushPopoverShown?: boolean;
	isBackupPaymentMethodModalRequired?: boolean;
	isProfessionalLocatorModalShown?: boolean;
	isWelcomeModalShown?: boolean;
	activeFinalExamSlug?: string;
	shouldShowConversionModal?: boolean;
	isCPTLegacyUpgradeBannerDismissed?: boolean;
	isCPTLegacyUpgradeAccepted?: boolean;
	isOtherProfessionAcknowledged?: boolean;
	[key: string]: boolean | string | undefined;
}

export enum UserAction {
	SIGN_UP = "SIGN_UP",
	SIGN_IN = "SIGN_IN",
	SELECT_A_PROFESSION = "SELECT_A_PROFESSION",
	SELECT_A_CERTIFICATION = "SELECT_A_CERTIFICATION",
	BECOME_A_MEMBER = "BECOME_A_MEMBER",
	UPGRADE_TO_YEARLY = "UPGRADE_TO_YEARLY",
	COURSE_DETAILS = "COURSE_DETAILS",
	PURCHASE_WORKSHOP = "PURCHASE_WORKSHOP",
	WORKSHOP_DETAILS = "WORKSHOP_DETAILS",
	RESUME_MEMBERSHIP = "RESUME_MEMBERSHIP",
	WELCOME = "WELCOME",
	START_PRACTICE_EXAM = "START_PRACTICE_EXAM",
	OPEN_WIZARD = "OPEN_WIZARD",
	OPEN_ONBOARDING_CHECKLIST = "OPEN_ONBOARDING_CHECKLIST",
	OPEN_PHONE_NUMBER = "OPEN_PHONE_NUMBER",
}

export enum UserType {
	Guest = "Guest", // Logged Out "Anonymous" User
	User = "User", // Logged-In User (Non-member)
	Member = "Member", // Logged-In User (Member)
	CertifiedMember = "CertifiedMember", // Logged-In User (Member w/ Completed Certificate)
}

export interface UserAvailability
	extends Prisma.UserPreferencesGetPayload<{
		select: {
			isPublic: true;
			isOpenToJobs: true;
			isOpenToOnlineSessions: true;
			isOpenToClients: true;
			isOpenToNetworking: true;
		};
	}> {}
